var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamicTable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DCAA742E-F782-4EF6-826C-A974AA551F4E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20 L20,20 L20,0 L0,0 L0,20 Z M1,3 L19,3 L19,1 L1,1 L1,3 Z M1,7.001 L19,7.001 L19,4 L1,4 L1,7.001 Z M1,11 L19,11 L19,8 L1,8 L1,11 Z M1,15 L19,15 L19,12 L1,12 L1,15 Z M1,19 L19,19 L19,16 L1,16 L1,19 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "2 6 4 6 4 5 2 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "2 10 4 10 4 9 2 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "2 14 4 14 4 13 2 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "2 18 4 18 4 17 2 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "6 6 9 6 9 5 6 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "6 10 9 10 9 9 6 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "6 14 9 14 9 13 6 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "6 18 9 18 9 17 6 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    points: "10.5 6 13.5 6 13.5 5 10.5 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    points: "10.5 10 13.5 10 13.5 9 10.5 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    points: "10.5 14 13.5 14 13.5 13 10.5 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    points: "10.5 18 13.5 18 13.5 17 10.5 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    points: "15 6 18 6 18 5 15 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    points: "15 10 18 10 18 9 15 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    points: "15 14 18 14 18 13 15 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    points: "15 18 18 18 18 17 15 17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicTable);
export default __webpack_public_path__ + "static/media/DynamicTable.6d3544c3c1a5bfcd58e20a27910ea196.svg";
export { ForwardRef as ReactComponent };